const attractCatalog = new Set([
    'dp-results-inactivity_click:cta',
    'dp-results-inactivity_click:cta-dp',
    'dp-results-inactivity_click:cta-hsa',
    'dp-results-inactivity_click:x',
]);

export default attractCatalog;
